
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TargetSelection, targetSelectionName, IndividualTargetSelection } from 'ah-api-gateways';
import { getPhoneNumber } from 'ah-common-lib/src/helpers/calls';

@Component
export default class NotificationTargetBlock extends Vue {
  @Prop({ required: true }) target!: TargetSelection;

  getPhoneNumber = getPhoneNumber;

  get isIndividual() {
    return !!(this.target as IndividualTargetSelection).individual;
  }

  get title() {
    return targetSelectionName(this.target);
  }
}
